/**
 * @desc 更新
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(body: defs.wms.DemandOrderRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/wms/demandOrder/update`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
